"use client";

import { useEffect } from "react";
import { extractReferrer, storeReferrer } from "@shared/src/utils/referral";

export function ReferralTracker() {
  useEffect(() => {
    const referrer = extractReferrer();
    if (referrer) {
      storeReferrer(referrer);
    }
  }, []);

  return null; // This component doesn't render anything
}
